import Image from 'next/image';
import { useRouter } from 'next/router';
import { event } from 'nextjs-google-analytics';


const FreeConsultation = () => {
  const router = useRouter();

  const handleClick = () => {
    event("free-consultation", {
      event_category: "mamapedia-article",
      event_label: router.asPath,
    })

    window.open("https://wa.me/6281387267440", "_blank");
  }

  return (
    <div
      className="fixed z-30 cursor-pointer right-5 bottom-10 md:right-8"
      onClick={handleClick}
    >
      <Image
        src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/free-consultation.png"}
        alt="free consultation icon"
        quality={100}
        width={260}
        height={348}
        className={`cursor-pointer h-[87px] w-[65px] md:hidden`}
      />
      <Image
        src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/free-consultation-pc.png"}
        alt="free consultation icon"
        quality={100}
        width={1068}
        height={348}
        className={`cursor-pointer h-[87px] w-[267px] hidden md:block`}
      />
    </div>
  )
}

export default FreeConsultation
